module.exports = __webpack_public_path__ + "img/Label_Info.59646c3b.svg";